export default {
  BASE_URL: process.env.REACT_APP_API_URL,
  USER_REGISTER: '/service/services',
  GENERATE_URL: '/service/services/generate',
  GET_FORM_DATA: '/service/services/generatedData/',
  GET_VALID_REGISTRATION_NUMBER: '/check-br-number/',
  GET_VALID_APPLICANT_EMAIL: '/check-applicant-email/',
};
